'use client'

import { Builder, withChildren } from '@builder.io/react'

import CountdownWrapper from './CountdownWrapper'

Builder.registerComponent(withChildren(CountdownWrapper), {
  name: 'CountdownWrapper',
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/clock.svg',
  inputs: [
    {
      name: 'endTime',
      type: 'date',
      showIf: (properties) => properties.get('behavior') === 'static',
    },
    { name: 'completionMessage', type: 'html' },
    {
      name: 'behavior',
      type: 'text',
      enum: ['static', 'dynamic'],
      defaultValue: 'static',
    },
    {
      name: 'dynamicDays',
      type: 'number',
      defaultValue: 0,
      showIf: (properties) => properties.get('behavior') === 'dynamic',
    },
    {
      name: 'dynamicHours',
      type: 'number',
      defaultValue: 0,
      showIf: (properties) => properties.get('behavior') === 'dynamic',
    },
    {
      name: 'dynamicMinutes',
      type: 'number',
      defaultValue: 0,
      showIf: (properties) => properties.get('behavior') === 'dynamic',
    },
    {
      name: 'dynamicSeconds',
      type: 'number',
      defaultValue: 0,
      showIf: (properties) => properties.get('behavior') === 'dynamic',
    },
    {
      name: 'includedChildren',
      type: 'array',
      hideFromUI: true,
      subFields: [
        {
          name: 'item',
          type: 'uiBlocks',
          defaultValue: [],
        },
      ],
      defaultValue: [
        {
          item: [],
        },
      ],
    },
  ],
})
